"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrap = (0, _glamor.css)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  background: "#000",
  padding: "6vw",
  height: "42.2vw",
  overflow: "hidden"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  height: "50vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  height: "auto"
}));

var backgroundImg = function backgroundImg(bg) {
  return (0, _glamor.css)((0, _css.bgCover)(bg), {
    position: "absolute",
    top: -30,
    left: -30,
    width: "calc(100% + 60px)",
    height: "calc(100% + 60px)",
    filter: "blur(35px)",
    opacity: 0.5
  }, (0, _css.maxWidth)(_css.breakpoints.super4k)({
    filter: "blur(30px)"
  }), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
    filter: "blur(25px)"
  }), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
    filter: "blur(20px)"
  }), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
    filter: "blur(15px)"
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    filter: "blur(10px)"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    filter: "blur(5px)"
  }));
};

var vidLink = function vidLink(bg) {
  return (0, _glamor.css)((0, _css.bgContain)(bg), {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "50vw",
    height: "30vw",
    margin: "auto",
    cursor: "pointer"
  }, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
    width: "72vw",
    height: "40vw"
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    width: "81vw",
    height: "45vw"
  }));
};
var close = (0, _glamor.css)({
  position: "absolute",
  top: "10px",
  right: "-30px",
  zIndex: 1,
  width: (0, _css.unitRem)(1),
  height: (0, _css.unitRem)(1),

  cursor: "pointer",
  transition: "transform 0.3s",
  color: "#fff",
  fontSize: "28px",
  background: "none",
  border: "none",
  ":hover": {
    transform: "scale(1.1, 1.1)",
    color: "#aaa"
  },
  ":after": {
    content: '"✕"',
    width: "100%",
    textShadow: "0 0 2px rgba(0,0,0,0.5)"
  }
});
var icon = (0, _glamor.css)({
  position: "absolute",
  fill: _css.pallets.white,
  left: "50%",
  marginLeft: "-40px",
  top: "50%",
  marginTop: "-40px",
  zIndex: 2,
  width: 80,
  height: 80,

  transition: "transform " + _css.time.fast + ", box-shadow " + _css.time.fast,

  ":hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 15px 50px rgba(0,0,0,0.35)"
  }
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  width: 120,
  height: 120,
  marginLeft: "-60px",
  marginTop: "-60px"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  width: 40,
  height: 40,
  marginLeft: "-20px",
  marginTop: "-20px"
}));
var smallHeading = (0, _glamor.css)(_fonts.superH2, {
  textTransform: "uppercase",
  margin: "auto",
  textAlign: "center",
  color: "#eee",
  zIndex: 1,
  marginTop: "-2.8vw",
  position: "absolute"
}, (0, _css.maxWidth)("100em")({
  marginTop: "-2.86vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  marginTop: "-2.9vw"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: "-4vw"
}));

var VideoLinkSection = function (_React$Component) {
  (0, _inherits3.default)(VideoLinkSection, _React$Component);

  function VideoLinkSection(props) {
    (0, _classCallCheck3.default)(this, VideoLinkSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoLinkSection.__proto__ || (0, _getPrototypeOf2.default)(VideoLinkSection)).call(this, props));

    _this.onClickVideo = function () {
      if (!_this.state.playing) {
        if (_this.state.player) _this.state.player.playVideo();
        _this.setState({ playing: true });
        if (window && _epicTracking) {
          window.trackEpicIntrection({
            eventCategory: "Engagement",
            eventAction: "Video",
            eventLabel: _this.state.player.getVideoData().title,
            interactionType: "click",
            eventValue: 1
          });
        }
      }
    };

    _this.onCloseVideo = function () {
      if (_this.state.playing) {
        if (_this.state.player) _this.state.player.stopVideo();
        _this.setState({ playing: false });
      }
    };

    _this.state = {
      playing: false,
      player: null
    };
    return _this;
  }

  (0, _createClass3.default)(VideoLinkSection, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          bg = _props.bg,
          typeLabel = _props.typeLabel,
          YTid = _props.YTid;

      return _react2.default.createElement(
        "section",
        (0, _extends3.default)({}, wrap, { onClick: this.onCloseVideo }),
        _react2.default.createElement("div", { className: backgroundImg(bg) }),
        typeLabel && _react2.default.createElement(
          "div",
          { className: smallHeading },
          typeLabel
        ),
        _react2.default.createElement(
          "div",
          { className: vidLink(bg), onClick: this.onClickVideo },
          _react2.default.createElement(
            "div",
            {
              style: {
                width: "100%",
                height: "100%",
                display: this.state.playing ? "" : "none"
              } },
            _react2.default.createElement("iframe", {
              width: "100%",
              height: "100%",
              src: "https://www.youtube-nocookie.com/embed/" + YTid + "?rel=0",
              title: typeLabel,
              frameBorder: "0",
              allowFullScreen: true
            })
          )
        )
      );
    }
  }]);
  return VideoLinkSection;
}(_react2.default.Component);

exports.default = VideoLinkSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Marketing/VideoLinkSection/VideoLinkSection.jsx
// module id = 2849
// module chunks = 0